'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import React from 'react';
interface Props {
  isChecked: boolean;
  handleChangeSwitch: () => void;
}
function ExpensesMetricChartSwitch(t0) {
  const $ = _c(16);
  const {
    isChecked,
    handleChangeSwitch
  } = t0;
  let t1;
  if ($[0] !== handleChangeSwitch) {
    t1 = e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleChangeSwitch();
      }
    };
    $[0] = handleChangeSwitch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isChecked ? "bg-primary" : "bg-muted dark:bg-muted/80";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("relative h-[21px] w-[42px] rounded-full p-0 transition-colors duration-500", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = isChecked ? "translate-x-5" : "translate-x-0";
  let t5;
  if ($[4] !== t4) {
    t5 = cn("bg-background absolute top-[1.5px] h-[18px] w-[18px] rounded-full transition-transform duration-300", t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <div data-slot="switch-thumb" className={t5} />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t6) {
    t7 = <div data-slot="switch-track" className={t3}>{t6}</div>;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== handleChangeSwitch || $[12] !== isChecked || $[13] !== t1 || $[14] !== t7) {
    t8 = <div data-slot="switch-container" className="cursor-pointer" onClick={handleChangeSwitch} role="switch" aria-checked={isChecked} tabIndex={0} onKeyDown={t1}>{t7}</div>;
    $[11] = handleChangeSwitch;
    $[12] = isChecked;
    $[13] = t1;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}
export { ExpensesMetricChartSwitch };